import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogContext from '../context/LogContext';
import {homeScroll} from '../smoothScroll';
export default function Shop() {
  const myContext = useContext(LogContext);
  const navigate = useNavigate();
  const [productArray, setProductArray] = useState([]);
  const [cart, setCart] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [categories, setCategories] = useState([]);
  const [size, setSize] = useState();
  const [color, setColor] = useState();
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(50000);
  const [isChanging,setIsChanging]=useState(true)
  const [filter, setFilter] = useState({
    categories:[],material:[], rating:[], discount:[]
  });
  const [material, setMaterial] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [rating, setRating] = useState([]);

  const products = async () => {
    var filter = { size, minPrice, maxPrice, color, categories, material, rating, discount };
    if (localStorage.getItem('filter')) {
      filter = JSON.parse(localStorage.getItem('filter'));
      console.log(localStorage.getItem('filter'));
    }
    try {
        const response = await fetch(`http://localhost:8001/shopAll`, {
      method: 'POST',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ filter })
    });
    if (response.ok) {
      const data = await response.json();
      setProductArray(data["productsArray"]);
      console.log(data["productsArray"].length)
    } else {
      console.log("can't get all the shop data");
    }
    } catch (error) {
      console.log("Some error occured", error)
    }
  
  }

  const cartUpdate = async () => {
    try {
      const response = await fetch('http://localhost:8001/cartData', {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: myContext.user.email })
      });
      if (response.ok) {
        const productArray = await response.json();
        setCart(productArray.cartItems);
      } else {
        console.log("Can't retrieve data from the user collections in the database");
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  }

  const addToCartHandler = async (itemID) => {
    try {
      if (!myContext.user) {
      navigate('/signIn');
    } else if (cart.some(items => items.productID === itemID)) {
      console.log("already In cart");
    } else {
      const response = await fetch('http://localhost:8001/cartHandler', {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ "email": myContext.user.email, "itemID": itemID})
      });
      if (response.ok) {
        myContext.updateCart(itemID);
        console.log("info send successfully");
      } else {
        console.log("info not send successfully");
      }
    }
    } catch (error) {
      console.log("Some error occured", error);
    }
  }

  const whishlistHandler = async (productID) => {
    try {
      const response = await fetch('http://localhost:8001/addToWishlist', {
      method: 'POST',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ email: myContext.user.email, productID })
    });
      if (response.ok) {
        console.log("added to wishlist");
      } else {
        console.log("problem sending data");
      }
    } catch (error) {
      console.log("error Occured", error);
    }
  }

  const filterPopUp = () => {
    const filter = document.getElementById('filter-dropdown');
    setIsChanging(true)
    if (showFilter) {
      filter.style.position = "fixed";
      filter.style.left = "-100rem";
      setShowFilter(false);
    } else {
      filter.style.position = "fixed";
      filter.style.left = "0%";
      setShowFilter(true);
    }
  }

  const handleApply = async () => {
    setFilter({ size, minPrice, maxPrice, color, categories, material, rating, discount });
    localStorage.setItem('filter', JSON.stringify({ size, minPrice, maxPrice, color, categories, material, discount, rating }));
    products();
  };

  const handleCheckboxChangeCat = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setCategories((prev) => [...prev, value]);
    } else {
      setCategories((prev) => prev.filter((category) => category !== value));
    }
  };
  const handleCheckboxChangeDis = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setDiscount((prev) => [...prev, value]);
    } else {
      setDiscount((prev) => prev.filter((category) => category !== value));
    }
  };
  const handleCheckboxChangeRat = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setRating((prev) => [...prev, value]);
    } else {
      setRating((prev) => prev.filter((category) => category !== value));
    }
  };
  const handleCheckboxChangeMat = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setMaterial((prev) => [...prev, value]);
    } else {
      setMaterial((prev) => prev.filter((category) => category !== value));
    }
  };

  useState(() => {
    if (localStorage.getItem('filter') && !isChanging) {
      setFilter(JSON.parse(localStorage.getItem('filter')));
    }
    products();
  });

  useEffect(() => {
    cartUpdate();
  }, [cart]);
  useEffect(()=>{
    if (localStorage.getItem('filter')) {
      setFilter(JSON.parse(localStorage.getItem('filter')));
    }
  },[isChanging]);

  return (
    <div>
      <section id="new-arrivals" className="new-arrivals">
        <div className="container">
          <div className="section-header">
            <div className='filter-section'>
              <button className='btn filter-btn pull-right' onClick={filterPopUp}>Filter <i className="fa-solid fa-filter"></i></button>
            </div>
            <div className='filter-dropdown' id="filter-dropdown">
              <button className='btn btn-cross' onClick={filterPopUp}><i className="fa-solid fa-xmark"></i></button>
              <div className='row'>
                <div className='col-6'>
                  <div className='categories'>
                    <p className='head'>Categories</p>
                    <div className='btn-group'>
                      <input type="checkbox" name="Sprituals" id="" value={'Sprituals'} onChange={handleCheckboxChangeCat} />
                      <label htmlFor="Sprituals">Sprituals</label><br />
                      <input type="checkbox" name="Decor" id="" value={"Decor"}  onChange={handleCheckboxChangeCat} />
                      <label htmlFor="Decor">Decor</label> <br />
                      <input type="checkbox" name="Kitchen" id="" value={'Kitchen'}  onChange={handleCheckboxChangeCat} />
                      <label htmlFor="Kitchen">Kitchen</label><br />
                      <input type="checkbox" name="Gift" id="" value={'Gift'}  onChange={handleCheckboxChangeCat} />
                      <label htmlFor="Gift">Gift</label><br />
                      <input type="checkbox" name="Festive" id="" value={'Festive'}  onChange={handleCheckboxChangeCat} />
                      <label htmlFor="Festive">Festive</label>
                    </div>
                  </div>
                  <div className='size-option'>
                    <p className='head'>Size Options</p>
                    <div className='btn-group'>
                      <button className='size-btn' onClick={() => { setSize('S') }}>S</button>
                      <button className='size-btn' onClick={() => { setSize('M') }}>M</button>
                      <button className='size-btn' onClick={() => { setSize('L') }}>L</button>
                    </div>
                  </div>
                  <div className='discount'>
                    <p className='head'>Discount</p>
                    <div className='checkbox-group'>
                      <input type="checkbox" name="Sprituals" id="" value={50} checked={filter.discount.includes(50)} onChange={handleCheckboxChangeDis} />
                      <label htmlFor="Sprituals">50% & more</label><br />
                      <input type="checkbox" name="Decor" id="" value={40} checked={filter.discount.includes(40)} onChange={handleCheckboxChangeDis} />
                      <label htmlFor="Decor">40% & more</label> <br />
                      <input type="checkbox" name="Kitchen" id="" value={30} checked={filter.discount.includes(30)} onChange={handleCheckboxChangeDis} />
                      <label htmlFor="Kitchen">30% & more</label><br />
                      <input type="checkbox" name="Gift" id="" value={20} checked={filter.discount.includes(20)} onChange={handleCheckboxChangeDis} />
                      <label htmlFor="Gift">20% & more</label><br />
                      <input type="checkbox" name="Festive" id="" value={10} checked={filter.discount.includes(10)} onChange={handleCheckboxChangeDis} />
                      <label htmlFor="Festive">10% & more</label>
                    </div>
                  </div>
                </div>
                <div className='col-6'>
                  <div className='color-options'>
                    <p className='head'>Color Options</p>
                    <div className='color-circles'>
                      <button title="Golden" className='circle-color-btn' style={{ background: "#FFD700" }} onClick={() => { setColor('gold') }}></button>
                      <button title="White" className='circle-color-btn' style={{ background: "white" }} onClick={() => { setColor('white') }}></button>
                      <button title="Black" className='circle-color-btn' style={{ background: "black" }} onClick={() => { setColor('black') }}></button>
                      <button title="Silver" className='circle-color-btn' style={{ background: "silver" }} onClick={() => { setColor('silver') }}></button>
                    </div>
                  </div>
                  <div className='price-filter'>
                    <p className='head'>Price</p>
                    <div className='price-filter-group' style={{ display: "flex", flexDirection: "column" }}>
                      <div className='range-container'>
                        <div className='slider'>
                          <div className='range' style={{ left: `${minPrice / 500}%`, width: `${(maxPrice - minPrice) / 500}%` }}></div>
                        </div>
                        <input
                          type="range"
                          className="input-range"
                          min="0"
                          max="50000"
                          value={minPrice}
                          onChange={(e) => setMinPrice(Number(e.target.value))}
                          style={{ position: "absolute", zIndex: 1 }}
                        />
                        <input
                          type="range"
                          className="input-range"
                          min="0"
                          max="50000"
                          value={maxPrice}
                          onChange={(e) => setMaxPrice(Number(e.target.value))}
                          style={{ position: "absolute", zIndex: 2 }}
                        />
                      </div>
                    </div>
                    <div className='filter-break'>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|<sub>10000</sub>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|<sub>20000</sub>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|<sub>30000</sub>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|<sub>40000</sub>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div className='min-max'>
                      <button className=' btn-price'>&#8377; {minPrice != 0 ? minPrice : "Min"}</button>
                      to
                      <button className=' btn-price'>&#8377; {maxPrice}</button>
                    </div>
                  </div>
                  <div className='rating'>
                    <p className='head'>Ratings</p>
                    <div className='checkbox-group'>
                      <input type="checkbox" name="4star" id="" value={4} checked={filter.rating.includes(4)} onChange={handleCheckboxChangeRat} />
                      <label htmlFor="4star">4 <i className="fa-solid fa-star"></i> & above</label><br />
                      <input type="checkbox" name="3star" id="" value={3} checked={filter.rating.includes(4)} onChange={handleCheckboxChangeRat} />
                      <label htmlFor="3star">3 <i className="fa-solid fa-star"></i> & above</label> <br />
                      <input type="checkbox" name="2star" id="" value={2} checked={filter.rating.includes(4)} onChange={handleCheckboxChangeRat} />
                      <label htmlFor="2star">2 <i className="fa-solid fa-star"></i> & above</label><br />
                      <input type="checkbox" name="1star" id="" value={1} checked={filter.rating.includes(4)} onChange={handleCheckboxChangeRat} />
                      <label htmlFor="1star">1 <i className="fa-solid fa-star"></i> & above</label><br />
                    </div>
                  </div>
                  <div className='material'>
                    <p className='head'>Material</p>
                    <div className='checkbox-group'>
                      <input type="checkbox" name="Brass" id="" value={"brass"} onChange={handleCheckboxChangeMat} />
                      <label htmlFor="Brass">Brass</label> <br />
                      <input type="checkbox" name="Silver" id="" value={"silver"} onChange={handleCheckboxChangeMat} />
                      <label htmlFor="Silver">Silver</label> <br />
                      <input type="checkbox" name="Plastic" id="" value={'plastic'} onChange={handleCheckboxChangeMat} />
                      <label htmlFor="Plastic">Plastic</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='apply-container' style={{ display: "flex" }}>
                <button className='btn btn-cart' onClick={handleApply}>Apply &nbsp;&nbsp;<i className="fa-solid fa-filter"></i></button>

                <button className='btn btn-cart' style={{ marginLeft: '11rem' }} onClick={handleApply}>Clear &nbsp;&nbsp;<i className="fa-solid fa-filter"></i></button>
              </div>
            </div>
            <h4>Home {'>'}Shop</h4>
          </div>
          <div className="new-arrivals-content">
            <div className="row" style={{display: "flex", flexWrap:"wrap"}}>
              {productArray.length !=0  &&
                productArray.map((product,index) => (
                  <div key={index} className="col-md-3 col-sm-6" style={{ }}>
                    <div>
                  <div className="single-new-arrival">
                    <div className="single-new-arrival-bg" style={{background:"white",minHeight:'250px'}}>
                      <img src={`media/products/${product.name}/1.webp`} alt="new-arrivals images"  />
                      <div className="single-new-arrival-bg-overlay"></div>
                      <div className="sale bg-1">
                        <p>sale</p>
                      </div>
                      <div className="new-arrival-cart">
                        <p>
                          <span className="lnr lnr-cart"></span>
                          <button  onClick={(e) => { addToCartHandler(product.productID) }}>add <span>to </span> cart</button>
                        </p>
                        <p className="arrival-review pull-right">
                          <span className="lnr lnr-heart" style={{cursor:"pointer"}} onClick={()=>{whishlistHandler(product.productID)}}></span>
                          <span className="lnr lnr-frame-expand"></span>
                        </p>
                      </div>
                    </div>
                    <h4><Link to="/product" onClick={(e) => {homeScroll('forProduct');localStorage.setItem('currentProduct',product.name);myContext.updateProduct(`${product.name}`) }}>{product.name}</Link></h4>
                    <p className="arrival-product-price">&#8377; {product.offerPrice} <span className='old-price'>&#8377; {product.MRP}</span></p>
                  </div>
                  </div>
                </div>
                ))

              }

            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
